export default __webpack_public_path__ + "static/media/Loony1.9cc70371.jpg";